






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'
import {InputTipoRelatorioSchema} from '@/schema/resource/TipoRelatorio/InputTipoRelatorioSchema'

@Component
export default class PersistTipoRelatorioView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTipoRelatorioSchema()
  tipoRelatorio = new TipoRelatorio()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionFormatoArquivoRelatorio.listFormatoArquivoRelatorio()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.tipoRelatorio.getTipoRelatorio(id)
    }

    $.await.done('getTipoRelatorio')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.tipoRelatorio.persistTipoRelatorio()
    await Helper.successAndPush(
      'system.success.persist',
      '/tipo-relatorio/list'
    )
  }
}
